import { createApiErrorHandler, useApiClient } from '@m43/core';
import { useMutation } from '@tanstack/react-query';
import { useToast } from '@cad-arc';
import { CadSearchResource, EventSearchExportRequest } from '@mark43/cad-api';
import { errorOccurredWhile } from '../common/helpers/error-occurred-while';

export function useExportEventSearchResultsMutation() {
    const apiClient = useApiClient();
    const toast = useToast();
    return useMutation((args: EventSearchExportRequest) => {
        return apiClient
            .request<CadSearchResource.EventSearchExport>({
                method: 'POST',
                url: 'cad_search/event/export',
                data: args,
            })
            .catch(
                createApiErrorHandler(() => {
                    toast({
                        status: 'error',
                        description: errorOccurredWhile('exporting results'),
                    });
                })
            );
    });
}
